export default [
    {
        bde_code: 'C',
        id: 1,
        name_ca: 'Taxació completa',
        name_en: 'Complete Valuation',
        name_es: 'Tasación Completa'
    },
    {
        bde_code: 'M',
        id: 2,
        name_ca: 'Model Automàtic',
        name_en: 'Automatic Model',
        name_es: 'Modelo Automático'
    },
    {
        bde_code: 'O',
        id: 3,
        name_ca: 'Taxació Online',
        name_en: 'Online Valuation',
        name_es: 'Tasación Online'
    },
    {
        bde_code: 'R',
        id: 4,
        name_ca: 'Resta de Taxacions',
        name_en: 'Other Valuations',
        name_es: 'Resto de Tasaciones'
    }
]


// WEBPACK FOOTER //
// ./src/options/appraisal_types.js